import React from "react";
import { useI18n } from "../lib/i18n";

export default function Footer() {
    const { t } = useI18n();
    return (
        <footer className="border-t border-brand-border bg-brand-bg" data-testid="footer">
            <div className="max-w-7xl mx-auto px-4 md:px-8 lg:px-12 py-12 grid md:grid-cols-3 gap-8 items-start">
                <div>
                    <div className="font-display text-2xl tracking-tight">QR Bracelet<span className="text-brand-primary">.</span></div>
                    <p className="mt-3 text-brand-textMuted text-sm max-w-xs">{t.footer.tagline}</p>
                </div>
                <div className="text-sm text-brand-textMuted">
                    <div className="font-mono tracking-widest text-xs text-brand-text/60 mb-3">CONTACT</div>
                    <div>contact@qrbracelet.ro</div>
                    <div>+40 700 000 000</div>
                </div>
                <div className="text-sm text-brand-textMuted md:text-right">
                    <div className="font-mono tracking-widest text-xs text-brand-text/60 mb-3">© {new Date().getFullYear()}</div>
                    QR Bracelet Pro • {t.footer.rights}
                </div>
            </div>
        </footer>
    );
}
